import { Chip, styled } from '@mui/material'
import * as colors from '@mui/material/colors'

export const WLDefaultChip = styled(Chip)(({ theme }) => ({
  margin: `0 ${theme.spacing(1)}`,
  backgroundColor: colors.orange[500],
  color: colors.grey[50],
}))

export const WLDemoChip = styled(Chip)(({ theme }) => ({
  margin: `0 ${theme.spacing(1)}`,
  backgroundColor: colors.brown[500],
  color: colors.grey[50],
}))
